/*==============================================================================
Feel free to add your own header, but please keep the following:
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Concrete v2.0.5
https://github.com/Elkfox/Concrete
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
==============================================================================*/

window.concrete = window.concrete || {};

// perhaps turn into an assign in function?
concrete.strings = {
  soldOut: "Uitverkocht",
  addToCart: "In winkelwagen",
  unavailable: "Translation missing: nl.product.unavailable"
};

concrete.urlParams = {};

/*================ Concrete ================*/
// =require concrete/cache.js
// replace urlparameter
concrete.replaceUrlParam = function(url, paramName, paramValue){
    if(paramValue == null)
        paramValue = '';
    var pattern = new RegExp('\\b('+paramName+'=).*?(&|$)')
    if(url.search(pattern)>=0){
        return url.replace(pattern,'$1' + paramValue + '$2');
    }
    return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue
}

concrete.removeUrlParam = function(url, paramName) {
  // Use this function incase we are not removing the url of the current page.
  let value = concrete.getUrlParameterByName(paramName, url);
  let newUrl = '';
  if(url.indexOf('?'+paramName+'='+value) > -1) {
    if (location.search.split('&').length > 1) {
      newUrl = url.replace(paramName+'=', '').replace(value+'&', '');
    } else {
      newUrl = url.replace('?'+paramName+'=', '').replace(value, '');
    }
  } else {
    newUrl = url.replace('&'+paramName+'=', '').replace(value, '');
  }

  return newUrl;
}

concrete.getUrlParameters = function(){
  parameters = {};
  if (location.search.length) {
    for (var value, i = 0, pairs = location.search.substr(1).split('&'); i < pairs.length; i++) {
      value = pairs[i].split('=');
      if (value.length > 1) {
        parameters[decodeURIComponent(value[0])] = decodeURIComponent(value[1]);
      }
    }
  }
  return parameters;
}

concrete.pushNewUrl = function(url, method) {
  method = method || 'push'
  if(method == 'push') {
    window.history.pushState({path: url}, '', url);
  } else {
    window.history.replaceState({path: url}, '', url);
  }
}

// Collection template sorting
concrete.getUrlParameterByName = function(parameter) {
  var url = decodeURIComponent(window.location.search.substring(1)),
      urlVariables = url.split('&'),
      parameterName;

  for (i = 0; i < urlVariables.length; i++) {
    parameterName = urlVariables[i].split('=');
    if (parameterName[0] === parameter) {
      return parameterName[1] === undefined ? true : parameterName[1];
    }
  }
};

concrete.urlParams = concrete.getUrlParameters();

// Javascript helpers for users with visual impairment

concrete.a11y = {

  // For use after scrolling using an anchor link, focus will change to the correct location so that hitting tab does not scroll the user back up.
  pageLinkFocus: function($element) {

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .data('a11y-focus')
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeData('a11y-focus')
        .removeAttr('tabindex');
    }
  },
  // Detect if the user has visited an anchored url if so update the focus to the correct location
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },
  // On click of an anchor link fire the page focus function
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },
  // Traps the focus within a specific container for example a popup that is open
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  // Stop trapping of focus
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }

}

concrete.Currency = (function() {

  var moneyFormat = '${{amount}}';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '',
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = (format || moneyFormat);
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;

    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 1, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return formatString.replace(placeholderRegex, value);
}

  return {formatMoney: formatMoney};

})();

/**
 *
 * From Shopifys "Slate" theme.
 * With a few modifications here and there.
 *
 */
concrete.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:section:reorder', this._onSectionReorder.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deslect', this._onBlockDeselect.bind(this));
};

concrete.Sections.prototype = _.assign({}, concrete.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof(constructor) === 'undefined') {
      return;
    }

    var instance = _.assign(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-type]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = this.instances.filter( function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);
      if (isEventInstance) {
        if (typeof(instance.onUnload) === 'function') {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    var instance = this.instances.filter(function(instance) {
      return instance.id === evt.detail.sectionId;
    })[0];

    if (typeof(instance) !== 'undefined' && typeof(instance.onSelect) === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = this.instances.filter(function(instance) {
      return instance.id === evt.detail.sectionId;
    })[0];

    if (typeof(instance) !== 'undefined' && typeof(instance.onDeselect) === 'function') {
      instance.onDeselect(evt);
    }
  },

_onSectionReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSectionReorder === 'function') {
      instance.onSectionReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = this.instances.filter(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (typeof(instance) !== 'undefined' && typeof(instance.onBlockSelect) === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = this.instances.filter(function(instance) {
      return instance.id === evt.detail.sectionId;
    })[0];

    if (typeof(instance) !== 'undefined' && typeof(instance.onBlockDeselect) === 'function') {
      instance.onBlockDeselect(evt);
    }
  },
  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(idx, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

// Javascript image helpers
concrete.Images = (function() {

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }
    for (var i = 0; i <= images.length-1; i++) {
      this.imageLoad(this.getImageUrl(images[i], size));
    }
  }

  function imageLoad(url) {
    new Image().src = url;
  }

  function getImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return concrete.Images.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|tiff|tif|bmp|bitmap)(\?v=\d+)$/i);

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return concrete.Images.removeProtocol(prefix[0] + "_" + size + suffix);
    }

    return null;

  }

  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  function switchImage(element, image, callback) {
    var oldSize = imageSize(element.src)
    var newSize = imageSize(image.src);
    var newImage = image.src;

    // If the iamge already has the size parameter remove it
    if (newSize !== null) {
      newImage = newImage.replace('_'+newSize, '')
    }

    var imageUrl = getImageUrl(newImage, oldSize);

    if (typeof callback === 'function') {
      callback(imageUrl, size, element);
    } else {
      element.src = imageUrl;
    }
  }

  function removeProtocol(url) {
    return url.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    getImageUrl: getImageUrl,
    imageSize: imageSize,
    imageLoad: imageLoad,
    switchImage: switchImage,
    removeProtocol: removeProtocol,
  };

})();

concrete.Collection = (function() {

  function Collection(container) {
    var $container = this.$container = $(container);
    this.selectors = {
      sortBy: '[data-sort]',
      viewBy: '[data-view]'
    }

    $container.on('change', this.selectors.sortBy, this._onSortByChange.bind(this));
    $container.on('click', this.selectors.viewBy, this._onViewByChange.bind(this));
  }

  Collection.prototype = _.assignIn({}, Collection.prototype, {

    _getSortBy: function() {
      return $(this.selectors.sortBy+' option:selected').val();
    },

    _onSortByChange: function() {

      var sortBy = this._getSortBy();
      this.$container.trigger({
        type: 'sortByChange',
        sortBy: sortBy
      });

      concrete.urlParams.sort_by = this.currentSortBy = sortBy;
      location.search = jQuery.param(concrete.urlParams);
    },

    _onViewByChange: function(evt) {
      evt.preventDefault();
      var viewBy = evt.target.getAttribute('data-view');

      this.$container.trigger({
        type: 'viewByChange',
        sortBy: viewBy
      });

      concrete.urlParams.view = this.currentViewBy = viewBy;
      location.search = jQuery.param(concrete.urlParams);
    },

    onUnload: function() {
      this.$container.off();
    }

  });
  return Collection;
  // intialize self
})();

concrete.Variants = (function() {

  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assign({}, Variants.prototype, {

    _getCurrentOptions: function() {
      var currentOptions = _.map(jQuery(this.singleOptionSelector, this.$container), function(el) {
        var $element = $(el);
        var type = $element.attr('type');
        var currentOption = {};
        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.attr('data-index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          return currentOption;
        }
      });

      currentOptions = _.compact(currentOptions);
      return currentOptions;
    },

    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = variants.filter(function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });
      return found[0];
    },

    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      // Push the variant attribute to the browser history and url
      concrete.pushNewUrl(concrete.replaceUrlParam(window.location.href, 'variant', variant.id))
    },

    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;

})();

concrete.Product = (function() {

  function Product(container) {
    var $container = this.$container = $(container);
    //var sectionId = $container.attr('data-section-id');
    this.settings = {
      enableHistoryState: $container.data('enable-history-state') || false,
    };

    // Create our selectors
    this.selectors = {
      addToCart: '[data-add-to-cart]',
      addToCartText: '#AddToCartText',
      comparePrice: '#ComparePrice',
      originalPrice: '#ProductPrice',
      onSale: '#OnSale',
      featuredImage: '#ProductPhotoImg',
      featuredImageContainer: '#ProductPhoto',
      originalSelectorId: '#productSelect',
      singleOptionSelector: '.single-option-selector',
      variantId: '[name=id]',
    };
    // Find the product json
    if (!$('#ProductJson').html()) {
      return;
    }
    this.productSingleObject = JSON.parse(document.getElementById('ProductJson').innerHTML);
    this._stringOverrides();
    this._initVariants();
  }


  Product.prototype = _.assignIn({}, Product.prototype, {

    _stringOverrides: function() {
      concrete.productStrings = concrete.productStrings || {};
      _.extend(concrete.strings, concrete.productStrings);
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        product: this.productSingleObject,
      };

      this.variants = new concrete.Variants(options);
      this.$container.on('variantChange', this._updateAddToCart.bind(this));
      this.$container.on('variantChange', this._updateVariantId.bind(this));
      this.$container.on('variantChange', this._updatePrices.bind(this));
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;
      $(this.selectors.productPrices).removeClass('hidden');

      if (variant) {
        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).text(concrete.strings.addToCart);
        } else {
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(concrete.strings.soldOut);
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(concrete.strings.unavailable);
        $(this.selectors.productPrices).addClass('hidden');
      }
    },

    _updatePrices: function(evt) {
      var variant = evt.variant;
      $(this.selectors.originalPrice).html(concrete.Currency.formatMoney(variant.price));
      if (variant.price < variant.compare_at_price) {
        $(this.selectors.onSale).removeClass('hidden')
        $(this.selectors.comparePrice).html(concrete.Currency.formatMoney(variant.compare_at_price, concrete.moneyFormat))
      } else {
        $(this.selectors.onSale).addClass('hidden');
      }
    },

    _updateVariantId: function(evt) {
      var variant = evt.variant;
      if (variant)
        $(this.selectors.variantId).val(variant.id);
    },

    onUnload: function() {
      this.$container.off();
    }

  });

  return Product;
  // intialize self
})();

/**
 *  This is an example of a new sections javascript. When you call: sections.register('empty-section', EmptySection)
 * the function EmptySection() will fire with a container set to $('[data-section-type=empty-section]')
 * This is also fired when the shopify:section:onload event fires.
 * You can edit the individual events to modify what happens in the theme editor yourself; but be aware that EmptySection() is also fired on page load on the live site.
 * Any functions unique to your section should do inside the EmptySection.prototype object and the function name should be preceeded with an _.
 * Format: _myFunction: function(arguments) { //Function code }.
 * Settings can be passed to this.settings by adding data attributes to your sections parent div and selecting them inside this.settings.
 **/
concrete.EmptySection = (function() {
  function EmptySection(container) {
    var $container = $(container);
    var sectionId = $container.data('section-id');
    this.settings = {};
    this.selectors = {};
  }

  EmptySection.prototype = _.assignIn({}, EmptySection.prototype, {
    onSectionUnload: function(evt) { },
    onSectionSelect: function(evt) { },
    onSectionDeselect: function(evt) { },
    onBlockSelect: function(evt) { },
    onBlockDeselect: function(evt) { },
  });

  return EmptySection;
})();



// Initialize on document ready
$(document).ready(function() {
  // Register sections js
  var sections = new concrete.Sections();
  sections.register('product', concrete.Product);
  sections.register('collection', concrete.Collection);
})

$('.slick-slider-home-featured-collection').slick({
  dots: true,
  //adaptiveHeight: true,
  mobileFirst : true,
  slidesToShow: 1,
  slidesToScroll: 1,
  focusOnSelect: true,
  arrows: true,
  nextArrow: '<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 32"><defs><style>.a{fill:##9B9B9B;}</style></defs><path class="a" d="M-30.564,0-16,14.292-1.446,0,0,1.347-16,17-32,1.347Z" transform="translate(0) rotate(-90)"/></svg>',
  prevArrow: '<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 32"><defs><style>.a{fill:##9B9B9B;}</style></defs><path class="a" d="M30.564,0,16,14.292,1.446,0,0,1.347,16,17,32,1.347Z" transform="translate(17) rotate(90)"/></svg>',
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    }
  ]
});

$('.review-section-slider').slick({
  dots: true,
  //adaptiveHeight: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  focusOnSelect: true,
  arrows: true,
  nextArrow: '<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 32"><defs><style>.a{fill:##9B9B9B;}</style></defs><path class="a" d="M-30.564,0-16,14.292-1.446,0,0,1.347-16,17-32,1.347Z" transform="translate(0) rotate(-90)"/></svg>',
  prevArrow: '<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 32"><defs><style>.a{fill:##9B9B9B;}</style></defs><path class="a" d="M30.564,0,16,14.292,1.446,0,0,1.347,16,17,32,1.347Z" transform="translate(17) rotate(90)"/></svg>',
  responsive: [
    {
      breakpoint: 850,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    }
  ]
});
$('.slick-slider-alt-reviews').slick({
  dots: false,
  //adaptiveHeight: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  focusOnSelect: true,
  arrows: true,
  nextArrow: '<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 32"><defs><style>.a{fill:##9B9B9B;}</style></defs><path class="a" d="M-30.564,0-16,14.292-1.446,0,0,1.347-16,17-32,1.347Z" transform="translate(0) rotate(-90)"/></svg>',
  prevArrow: '<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 32"><defs><style>.a{fill:##9B9B9B;}</style></defs><path class="a" d="M30.564,0,16,14.292,1.446,0,0,1.347,16,17,32,1.347Z" transform="translate(17) rotate(90)"/></svg>',
  responsive: [
    {
      breakpoint: 850,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});

document.addEventListener('DOMContentLoaded', () => {
  // Debounce util
  function debounce(callback, timeout = 300){
    let timer;

    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        callback.apply(this, args);
      }, timeout);
    };
  }

  // Featured Product Carousel Section
  const productCarousels = [...document.querySelectorAll('[js-product-carousel="container"]')];

  if (productCarousels.length > 0) {
    productCarousels.forEach((carousel) => {
      $(carousel).slick({
        dots: false,
        centerMode: true,
        centerPadding: '30%',
        mobileFirst : true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
        infinite: false,
        arrows: true,
        nextArrow: `[js-product-carousel="nextBtn-${carousel.dataset.sectionId}"]`,
        prevArrow: `[js-product-carousel="prevBtn-${carousel.dataset.sectionId}"]`,
        responsive: [
          {
            breakpoint: 850,
            settings: {
              centerMode: false,
              slidesToShow: 2.9,
              slidesToScroll: 1,
            }
          }
        ]
      });
    });
  }

  // Customer Reviews Section
  const reviewCarousels = [...document.querySelectorAll('[js-customer-reviews="container"]')];

  if (reviewCarousels.length > 0) {
    reviewCarousels.forEach((carousel) => {
      $(carousel).slick({
        dots: false,
        mobileFirst : true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
        infinite: false,
        arrows: true,
        nextArrow: `[js-customer-reviews="nextBtn-${carousel.dataset.sectionId}"]`,
        prevArrow: `[js-customer-reviews="prevBtn-${carousel.dataset.sectionId}"]`,
        responsive: [
          {
            breakpoint: 850,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            }
          }
        ]
      });
    });
  }

  // Featured Recommendations Section
  const recommendationsCarousels = [...document.querySelectorAll('[js-recommendations="container"]')];

  if (recommendationsCarousels.length > 0) {
    const settings = {
      dots: false,
      centerMode: true,
      centerPadding: '40%',
      mobileFirst : true,
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: true,
      infinite: false,
      arrows: false,
    };

    let init = false;

    function handleCarousels() {
      recommendationsCarousels.forEach((carousel) => {
        if (window.innerWidth <= 880) {
          if(!init) {
            $(carousel).slick(settings);
            init = true;
          }
        } else if (init) {
          $(carousel).slick('unslick');
          init = false;
        }
      });
    }

    handleCarousels();
    window.addEventListener('resize', debounce(() => handleCarousels()));
  }

  // Featured Videos Section
    const videosCarousels = [...document.querySelectorAll('[js-featured-videos="container"]')];

    if (videosCarousels.length > 0) {
      const settings = {
        dots: false,
        centerMode: true,
        centerPadding: '16%',
        mobileFirst : true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
        infinite: false,
        arrows: false
      };
  
      let init = false;
  
      function handleCarousels() {
        videosCarousels.forEach((carousel) => {
          if (window.innerWidth <= 880) {
            if(!init) {
              $(carousel).slick(settings);
              init = true;
            }
          } else if (init) {
            $(carousel).slick('unslick');
            init = false;
          }
        });
      }
  
      handleCarousels();
      window.addEventListener('resize', debounce(() => handleCarousels()));
    }

    
  // Video Block Section
  const videoContainers = [...document.querySelectorAll('[js-video="container"]')];

  if (videoContainers.length > 0) {
    videoContainers.forEach((container) => {
      if (container.dataset.autoplay === 'true') {
        return;
      }

      const video = container.querySelector('[js-video="video"]');
      const button = container.querySelector('[js-video="playButton"]');

      if (!video) {
        return;
      }

      video.addEventListener('play', () => {
        video.nextElementSibling.classList.add('is-hidden');
        video.controls = true;
      });

      button.addEventListener('click', () => {
        video.play();
      });
    });
  }

  // Rolling Banner Section
  const bannerContainers = [...document.querySelectorAll('[js-rolling-banner="container"]')];

  if (bannerContainers.length > 0) {
    const activeClass = 'rolling-banner__slide--active';

    bannerContainers.forEach((container) => {
      const slides = [...container.querySelectorAll('[js-rolling-banner="slide"]')];

      if (!slides.length) {
        return;
      }

      const slideDelay = container.dataset.slideDelay;
      let count = 1;

      function handleActiveSlide() {
        let index = count % slides.length;
        const current = container.querySelector(`.${activeClass}`);

        current.classList.remove(activeClass);
        slides[index].classList.add(activeClass);
        count++;
      }

      setInterval(handleActiveSlide, slideDelay);
    });
  }

  // Featured Articles Section
  const featuredArticlesSections = [...document.querySelectorAll('[js-featured-articles-slider]')];

  if (featuredArticlesSections.length > 0) {
    const featuredArticlesSettings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '40px',
      autoplay: false,
      dots: false,
      arrows: false,
    };

    let featuredArticlesSettingsInit = false;

    function handleFeaturedArticlesTitleHeight() {
      featuredArticlesSections.forEach((section)=> {
        const columnTitles = section.querySelectorAll('.featured-articles__article-text h3')
        if (columnTitles.length > 0) {
          function getMinHeight(columnTitles) {
            let minHeight = 0
            columnTitles.forEach((title) => {
              const currentHeight = title.offsetHeight
              if (minHeight < currentHeight) {
                minHeight = currentHeight
              }
            })
            return minHeight
          }
          
          function setMinHeight(columnTitles) {
            const minHeight = getMinHeight(columnTitles)
            columnTitles.forEach((title) => {
              title.style.height = `${minHeight}px`
            })
          }

          setMinHeight(columnTitles)
        }
      })
    }

    function handleFeaturedArticlesSections() {
      featuredArticlesSections.forEach((section) => {
        if (window.innerWidth <= 1024) {
          if(!featuredArticlesSettingsInit) {
            $(section).slick(featuredArticlesSettings);
            featuredArticlesSettingsInit = true;
          }
        } else if (featuredArticlesSettingsInit) {
          $(section).slick('unslick');
          featuredArticlesSettingsInit = false;
        }
      });
    }

    function initFeaturedArticlesSection() {
      handleFeaturedArticlesSections()
      handleFeaturedArticlesTitleHeight()
    }

    window.addEventListener('resize', debounce(() => {
      initFeaturedArticlesSection()
    }))
    initFeaturedArticlesSection()
  }

  const threeColumnsVideoSections = [...document.querySelectorAll('[js-three-columns-video-slider]')];

  // Three Columns with Video
  if (threeColumnsVideoSections.length > 0) {
    const threeColumnsVideoSettings = {
      slidesToShow: 1.25,
      slidesToScroll: 1,
      centerMode: false,
      autoplay: false,
      dots: false,
      arrows: false,
      infinite: false
    };

    let threeColumnsVideoSettingsInit = false;

    function handleThreeColumnsVideoSections() {
      threeColumnsVideoSections.forEach((section) => {
        if (window.innerWidth <= 1024) {
          if(!threeColumnsVideoSettingsInit) {
            $(section).slick(threeColumnsVideoSettings);
            threeColumnsVideoSettingsInit = true;
          }
        } else if (threeColumnsVideoSettingsInit) {
          $(section).slick('unslick');
          threeColumnsVideoSettingsInit = false;
        }
      });
    }

    function handleThreeColumnsVideoButtons() {
      threeColumnsVideoSections.forEach((section) => {
        const columnVideoButtons = section.querySelectorAll('[js-three-columns-video-trigger]')
        if (columnVideoButtons.length > 0) {
          columnVideoButtons.forEach((button) => {
            button.addEventListener('click', () => {
              const targetId = button.getAttribute('js-three-columns-video-trigger');
              const target = document.querySelector(`.${targetId}`)
              if (target) {
                target.closest('.three-columns-video__item').classList.add('three-columns-video__item--active')
                target.setAttribute('controls', 'controls')
                target.play()
              }
            })
          })
        }
      })
    }

    handleThreeColumnsVideoSections();
    handleThreeColumnsVideoButtons();
    window.addEventListener('resize', debounce(() => handleThreeColumnsVideoSections()));
  }
});

//Sticky Header:
function stickyHeader() {
  var mn = $(".nav-container");
      mns = "sticky";
      hdr = $('#shopify-section-theme-header').outerHeight() -  $('.nav-container').outerHeight();
      hw = $('#shopify-section-theme-header');
      hwh = $('#shopify-section-theme-header').outerHeight();

  $(window).scroll(function () {
      if ($(this).scrollTop() > hdr) {
          mn.addClass(mns);
          hw.outerHeight(hwh);
      } else {
          mn.removeClass(mns);
      }
  });
}
$(document).ready(stickyHeader);
$(window).on('resize',stickyHeader);

//Mobile sticky header
function mobileStickyHeader() {
  var width = $(window).width();
  if (width <= 1023){
    var mn = $(".theme-header");
        mns = "sticky";
        hdr = $('#shopify-section-theme-header').outerHeight() -  $('.theme-header').outerHeight();

        $(window).scroll(function () {
            if ($(this).scrollTop() > hdr) {
                mn.addClass(mns);
                // $(".header-search.search-wrapper").slideUp("15");
            } else {
                mn.removeClass(mns);
                // $(".header-search.search-wrapper").slideDown("15");
            }
        });
  } else {
    //Literally do nothing
  }
}
$(document).ready(mobileStickyHeader);
$(window).on('resize',mobileStickyHeader);

//Mobile Sticky Price and Button:
if($("#mobile-only-price-button").length ) {
  function mobileStickyProduct() {
    var a = function() {
      var b = $(window).scrollTop();
      var d = $("#mopb-anchor").offset().top -  $('#shopify-section-theme-header').outerHeight();
      var c=$("#mobile-only-price-button");
      if (b>d) {
        c.addClass("mopb-sticky"),
        c.css({'top':($(".theme-header").height()+'px')}),
        c.slideDown()
      } else {
        if (b<=d) {
          c.slideUp(),
          setTimeout(function() {
             c.removeClass("mopb-sticky");
             c.css({'top':(0)});
         }, 300);
        }
      }
    };
    $(window).scroll(a);a()
  }
  $(document).ready(mobileStickyProduct);
  $(window).on('resize',mobileStickyProduct);
}

//Mobile nav transparent overlay
$(document).ready(function() {
  $(".burger-nav").click(function() {
     $(".mobile-nav.mnoverlay").fadeIn("15");
  });
  $(".nav-close").click(function() {
    setTimeout(
      function() {
          $(".mobile-nav.mnoverlay").fadeOut("15");
      },
      400);
  });
});

//Product Page - Desktop Tabs
$(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });

//Product Page - Mobile Tabs and Article Tabs
$(document).ready(function() {
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
      acc[i].onclick = function(){
          if ($(this).hasClass("accordion-article__sidebar")) {
            $(".accordion-article__sidebar").not(this).removeClass("active");
            var panel = $(".show-hide-wrapper__article-sidebar").not(this.nextElementSibling);
            $(panel).slideUp(200);
            }

          /* Toggle between adding and removing the "active" class,
          to highlight the button that controls the panel */
          this.classList.toggle("active");

          /* Toggle between hiding and showing the active panel */
          var panel = this.nextElementSibling;
          // console.log(panel)
          // if (panel.style.display === "block") {
          //     panel.style.display = "none";
          // } else {
          //     panel.style.display = "block";
          // }
          $(panel).slideToggle(200);
      }
  }
});


var helpWidget = $('#helpWidget');
var helpWidgetIcon = $('#helpWidgetMainIcon');
helpWidgetIcon.click(function() {
  helpWidget.toggleClass("open");
});


$('.product-image-slider-single').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.product-image-slider-nav',
  nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 32"><path stroke="#BD9D65" stroke-width="2" d="M-30.564,0-16,14.292-1.446,0,0,1.347-16,17-32,1.347Z" transform="translate(0) rotate(-90)"/></svg></div>',
  prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 32"><path stroke="#BD9D65" stroke-width="2" d="M30.564,0,16,14.292,1.446,0,0,1.347,16,17,32,1.347Z" transform="translate(17) rotate(90)"/></svg></div>',
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        arrows: true,
        dots: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});

$('.product-image-slider-nav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.product-image-slider-single',
  dots: false,
  arrows: true,
  nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 32"><path stroke="#BD9D65" stroke-width="2" d="M-30.564,0-16,14.292-1.446,0,0,1.347-16,17-32,1.347Z" transform="translate(0) rotate(-90)"/></svg></div>',
  prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 32"><path stroke="#BD9D65" stroke-width="2" d="M30.564,0,16,14.292,1.446,0,0,1.347,16,17,32,1.347Z" transform="translate(17) rotate(90)"/></svg></div>',
  infinite: false,
  centerMode: false,
  focusOnSelect: true,
  vertical: true,
  verticalSwiping: false,
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 3.5,
        vertical: false,
        verticalSwiping: false
      }
    }
  ]
});

$('#bundle-add-to-cart-draw-handle').click(function() {
  $('#bundle-add-to-cart-draw').toggleClass("open");
  $('#bundle-add-to-cart-draw-contents').slideToggle(300);
});
//Converting points into credit
const formatter = new Intl.NumberFormat('en-UK', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 2
})

$('#lion-points').bind("DOMSubtreeModified",function(){
  var credit = $('#lion-points').text();
  //console.log(credit);
  var credit = parseFloat(credit / 100.00);
  //console.log(credit);
  var credit = formatter.format(credit);
  $('#points-for-id').html('<span class="money">'+credit+'</span>');
  $('.loyalty-earn').addClass('active');
  //console.log(credit);goto_pp
});

$('.points-list .points').bind("DOMSubtreeModified",function(){
  var credit2 = $('.points-list .points').text().replace(/,/g, '');
  var credit2 = parseInt(credit2);
  console.log(credit2);
  var credit2 = parseFloat(credit2 / 100);
  console.log(credit2);
  var credit2 = formatter.format(credit2);
  $('.points-list .total-credit').html('<span class="money">'+credit2+'</span>');
  $('.points-list .total-credit').addClass('active');
  console.log(credit2);
});



$('#lion-points').each(function(i,j){
 // console.log('found'); //the div
});

//tickbox on cart
$('body').on('click', '[data-name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        if(popupOnCheckout&&!offerRejected&&!offerAccepted){
          console.log("checkout show offer");
          return false;
        } else {
          $(this).submit();
        }
      } else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  // Find all YouTube videos
var $allVideos = $("iframe[src^='//www.youtube.com']"),

    // The element that is fluid width
    $fluidEl = $("body");

// Figure out and save aspect ratio for each video
$allVideos.each(function() {

  $(this)
    .data('aspectRatio', this.height / this.width)

    // and remove the hard coded width/height
    .removeAttr('height')
    .removeAttr('width');

});

// When the window is resized
$(window).resize(function() {

  var newWidth = $fluidEl.width();

  // Resize all videos according to their own aspect ratio
  $allVideos.each(function() {

    var $el = $(this);
    $el
      .width(newWidth)
      .height(newWidth * $el.data('aspectRatio'));

  });

// Kick off one resize to fix all videos on page load
}).resize();

var advancedFilterTitle = $('.tags.brand-tags > .filter-title');
var advancedFilters = $('.advanced-filters');

advancedFilterTitle.click(function() {
  $(this).toggleClass("open");
  $(this).siblings(advancedFilters).slideToggle(300);
});

$('.slide-menu-trigger').click(function(e) {
  var menuId = $(this).data('slide-menu');
  $('#'+menuId).fadeToggle();
  e.preventDefault();
});

$('.search-glass').click(function(e) {
  $('.header-search.search-wrapper').toggleClass('search-visible');
  $('.header-search__form input').trigger('focus');
  e.preventDefault();
});

// Article footer slider.
$(window).on('load resize orientationchange', function() {
  $('.article-featured-products-slider').each(function(){
    var $slider = $(this);
    if ($(window).width() > 768) {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    } else {
      $slider.slick({
        infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          nextArrow: '<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 32"><defs><style>.a{fill:##9B9B9B;}</style></defs><path class="a" d="M-30.564,0-16,14.292-1.446,0,0,1.347-16,17-32,1.347Z" transform="translate(0) rotate(-90)"/></svg>',
          prevArrow: '<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 32"><defs><style>.a{fill:##9B9B9B;}</style></defs><path class="a" d="M30.564,0,16,14.292,1.446,0,0,1.347,16,17,32,1.347Z" transform="translate(17) rotate(90)"/></svg>'
      });
    }
  });
});

if($(".blog-article").length > 0) {
  var target_element = $(".blog-article article")
  if (target_element && target_element.offset()?.top) {
    var bottom_of_element = target_element.offset().top + $(".blog-article article").outerHeight();
    $(window).bind('scroll', function() {
      if($(window).scrollTop() <= $('.blog-article article').offset().top + $('.blog-article article').outerHeight() - window.innerHeight) {
        $('.article-featured-products').addClass('fixed');
      } else {
        $('.article-featured-products').removeClass('fixed');
      }
    });
  }
}

//Minicart
const miniCart = document.querySelector("#CartLink")
if (miniCart) {
  miniCart.addEventListener("click", function () {
      document.body.classList.toggle("overlay--active");
  });
} else {
  console.error("Couldn't find miniCart");
}

const addToCartElements = document.querySelectorAll(".add-to-cart")
if (addToCartElements.length > 0) {
  addToCartElements.forEach(function (button) {
      button.addEventListener("click", function () {
        setTimeout(function() {
          document.body.classList.add("overlay--active");
        }, 300);
      });
  });
} else {
  console.error("Couldn't find addToCartElements");
}

// overlay
document.addEventListener("DOMContentLoaded", (event) => {
  const closeOverlayButtons = document.querySelectorAll("[close-overlay-button]");
  if (closeOverlayButtons.length > 0) {
    closeOverlayButtons.forEach((button) => {
      button.addEventListener("click", () => {
        document.body.classList.remove("overlay--active");
      });
    });
  } else {
    console.error("Couldn't find closeOverlayButtons");
  }
});

// Featured Products Slider
if($(".three-column__products__container").length > 0) {  
  $('.three-column__products__container').slick({
    slidesToShow: 3,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          dots: true
        }
      }
    ]
  }); 
}

// Review Blocks Slider
if($('.review-blocks__slider').length > 0) {
  $('.review-blocks__slider').slick({
    slidesToShow: 3,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          centerMode: false
        }
      }
    ]
  });
}

// Icon Blocks Slider
if($('.icon-blocks__slides').length > 0) {
  $('.icon-blocks__slides').slick({
    slidesToShow: 4.5,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          centerMode: true
        }
      }
    ]
  });
}

// Accordion
class AccordionElement extends HTMLElement {
  constructor() {
    super();
    this.accordion = this.querySelector(".accordion-element");
    this.panel = this.querySelector(".panel");
    this.accordion.addEventListener("click", this.toggleAccordion.bind(this));

    if (this.panel) {
      this.panel.style.transition = "max-height 0.3s ease-in-out";
    }
  }

  toggleAccordion() {
    if (this.accordion) {
      if (this.accordion.classList.contains("active")) {
        this.panel.style.maxHeight = "0";
        this.panel.classList.toggle("open");
        if (this.classList.contains("child")) {
          const parentPanel = this.closest(".panel");
          const parentPanelHeight = parentPanel.scrollHeight;
          parentPanel.style.maxHeight = parentPanelHeight + "px";
        }
        this.accordion.classList.remove("active");
        if (!this.panel.dataset.panel) return;
        document.documentElement.classList.toggle(this.panel.dataset.panel);
      } else {
        this.panel.classList.toggle("open");     
        if (this.classList.contains("child")) {
          const parentPanel = this.closest(".panel");
          const parentPanelHeight = parentPanel.scrollHeight;
          const childPanelHeight = this.panel.scrollHeight;
          const combinedHeight = parentPanelHeight + childPanelHeight;
          parentPanel.style.maxHeight = combinedHeight + "px";
          this.panel.style.maxHeight = combinedHeight + "px";
        } else {
          this.panel.style.maxHeight = this.panel.scrollHeight + "px";
        }
        this.accordion.classList.add("active");

        if (!this.panel.dataset.panel) return;
        document.documentElement.classList.toggle(this.panel.dataset.panel);
      }
    }
  }
}

customElements.define("accordion-element", AccordionElement);

// Featured Products Slider

if($('.featured-products__slides').length > 0) {
  $('.featured-products__slides').slick({
    slidesToShow: 4,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          centerMode: false
        }
      }
    ]
  });
}

